import React, { useCallback, useEffect, useState } from "react";

import { getAPIPayload } from "../../apis/getApi";
import JesseSourceAccessModal from "./JesseSourceAccessModal";
import { DANIELS_LAW_DISPLAY_NAME } from "../helpers/constants";

const STORAGE_KEY = "pending_jesse_source_access_id";

const JESSE_REDACT_ENABLED =
  String(process.env.REACT_APP_JESSE_REDACT_ENABLED || "").toLowerCase() === "true";

export const captureJesseSourceAccessFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const accessRequestId = params.get("jesse_source_access");
  if (accessRequestId) {
    localStorage.setItem(STORAGE_KEY, accessRequestId);
  }
};

/**
 * Shows a login popup when the property owner has pending Daniels Law source-access requests.
 */
const JesseSourceAccessGate = ({ onAuthorizationCompleted }) => {
  const [pendingRequest, setPendingRequest] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const loadPendingRequest = useCallback(async () => {
    if (!JESSE_REDACT_ENABLED || !localStorage.getItem("authToken")) {
      return;
    }

    const accessRequestId = localStorage.getItem(STORAGE_KEY);
    const query = accessRequestId
      ? `?access_request_id=${encodeURIComponent(accessRequestId)}`
      : "";

    try {
      const response = await getAPIPayload({
        url: `jesse/pending-source-access${query}`,
        token: true,
      });

      const rows = Array.isArray(response?.data) ? response.data : [];
      const request = rows[0] || null;

      if (response?.success && request?.id) {
        setPendingRequest({
          ...request,
          law_display_name: request.law_display_name || DANIELS_LAW_DISPLAY_NAME,
        });
        setModalOpen(true);
        return;
      }

      if (accessRequestId) {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch {
      // Non-blocking gate.
    }
  }, []);

  useEffect(() => {
    void loadPendingRequest();
  }, [loadPendingRequest]);

  const handleCompleted = (action) => {
    const completedRequest = pendingRequest;
    localStorage.removeItem(STORAGE_KEY);
    setModalOpen(false);
    setPendingRequest(null);
    onAuthorizationCompleted?.(action, completedRequest);
  };

  return (
    <JesseSourceAccessModal
      open={modalOpen}
      request={pendingRequest}
      onClose={() => {
        setModalOpen(false);
        localStorage.removeItem(STORAGE_KEY);
      }}
      onCompleted={handleCompleted}
    />
  );
};

export default JesseSourceAccessGate;
